import { FilterLiveForm } from "ra-core";
import { SearchInput } from "@/components/admin/search-input";

/**
 * Fixed header of the mobile list pages and the mobile dashboard: the page
 * title, and below it a search field when the page is searchable (the field
 * writes the `q` filter of the surrounding list context). Pair it with
 * <MobileContent search> so the content starts below the taller header.
 */
export const MobileListHeader = ({
  title,
  searchPlaceholder,
}: {
  title: string;
  /** Renders the search field when set (the placeholder of the field). */
  searchPlaceholder?: string;
}) => (
  <header className="fixed top-0 right-0 left-0 z-10 flex flex-col gap-2 border-b border-border bg-white px-4 pt-3 pb-3">
    <h1 className="text-xl font-semibold text-brand-navy">{title}</h1>
    {searchPlaceholder !== undefined ? (
      <FilterLiveForm>
        <SearchInput source="q" placeholder={searchPlaceholder} />
      </FilterLiveForm>
    ) : null}
  </header>
);
